<div class="pt-16 pl-32 pr-32">
    <app-breadcrumb [items]="breadcrumbItems" class="mt-10"></app-breadcrumb>
</div>
<div class="flex flex-row justify-between header-background mt--20">
  <div class="flex flex-row flex-auto pl-32 pt-16 pr-32 pb-16">
    <div class="flex flex-row pt-6">
      <mat-icon svgIcon="arrow_back" class="icon cursor-pointer mt-0"
        (click)="goToJobs()"></mat-icon>
    </div>
    <div class="flex flex-col flex-auto justify-between pl-24">
      <div class="flex flex-row mb-8">
        <div *ngIf="!isDetailsLoading; else detailsLoader" class="mat-subtitle-1 fw-600 fs-20 mb-0 mr-24">
              {{ jobName | titlecase }}
        </div>
        <div class="flex items-center status pl-8 pr-8 pt-2 pb-2" [ngClass]="status">
            <span>
    <ng-container *ngIf="!isInProgress(status); else loadingStatus">
      <mat-icon
        [svgIcon]="getStatusIcon(status)"
        class="icon-md p-2 mr-6"
        [ngClass]="status">
      </mat-icon>
    </ng-container>

    <ng-template #loadingStatus>
      <mat-spinner diameter="16" class="mr-8" color="primary" mode="indeterminate"></mat-spinner>
    </ng-template>
  </span>
    <span>{{ getStatusLabel(status) }}</span>

        </div>
      </div>
      <div class="flex flex-row items-center mt--4">
        <div class="fs-14 fw-400 pr-16 flex items-center vertical-indicator">{{ 'INSTANCE_DETAILS.ENVIRONMENT_NAME' | transloco }}: <span *ngIf="!isDetailsLoading; else detailsLoader" class="ml-4">{{data?.name ? data?.name : '-'}}</span></div>
        <div class="flex flex-row justify-center items-center vertical-indicator fs-14 fw-400 ml-16 pr-16">
            {{ 'INSTANCE_DETAILS.RUNBOOK' | transloco }}:  <span class="ml-4" *ngIf="!isDetailsLoading; else detailsLoader" [ngClass]="{ 'purple-font cursor-pointer underline': runbookName, '': !runbookName }" (click)="runbookPopup()">{{ (runbookName | titlecase) || '-' }}</span>
        </div>
        <div class="flex flex-row justify-center items-center vertical-indicator fs-14 fw-400 ml-16 pr-16">
            {{ 'SCHEDULE.SCHEDULE' | transloco | titlecase }}:  <span class="ml-4" *ngIf="!isDetailsLoading; else detailsLoader" [ngClass]="{ 'purple-font cursor-pointer underline': scheduleName, '': !scheduleName }" (click)="schedulePopup()">{{(scheduleName | titlecase) || '-' }}</span> 
        </div>
        <ng-container *ngIf="!isDetailsLoading && matchedRunbook; else detailsLoader">
          <div *ngIf="isAzure && matchedRunbook?.targets?.primary?.targetADOPipeline?.pipelineId"
            class="flex flex-row justify-center vertical-indicator items-center fs-14 fw-400 ml-16 pr-16 purple-font cursor-pointer underline"
            (click)="redirectADO()">
            <span>{{ 'ADD_INSTANCE.ADO_PIPELINE' | transloco }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="!isDetailsLoading; else detailsLoader">
        <div *ngIf="isAzure && jobId"
            class="flex flex-row justify-center vertical-indicator items-center fs-14 fw-400 ml-16 pr-16 purple-font cursor-pointer underline"
            (click)="redirectBuildPipeline()">
            <span>{{ 'ADD_INSTANCE.BUILD_PIPELINE' | transloco }}</span>
        </div>
       </ng-container>
        <div *ngIf="!isDetailsLoading; else detailsLoader" class="flex flex-row justify-center vertical-indicator items-center fs-14 fw-400 ml-16 pr-16 purple-font cursor-pointer underline" (click)="getConfirmation()">
            <span>{{ 'JOBS.COB_MONITOR' | transloco }}</span>
        </div>
        <div class="flex flex-row justify-center items-center fs-14 fw-400 ml-16 pr-16">
            <span>{{ 'JOBS.EXECUTION_DATE' | transloco }}: <span class="ml-4">{{cobDate ? (cobDate | date:'MMM d, y') : '-' }}</span></span>
        </div>
          <ng-template #detailsLoader>
    <div class="flex item-center ml-4 pl-6 pr-16 loader">
      <ngx-skeleton-loader 
        count="1" 
        appearance="line">
      </ngx-skeleton-loader>
    </div>
  </ng-template>
      </div>
    </div>
  </div>
</div>
<div class="flex items-center justify-between stage">
  <div class="flex items-center">
    <div class="mat-subtitle-2 mb-0 fs-24 fw-600">{{'JOBS.STAGE' | transloco}} </div>
    <!-- @if (showRunbook) { -->
      <div class="ml-16 search-stage">
        <app-search-filter class="mt-20 ml-20" placeholder="SEARCH.SEARCH" (changed)="search($event)"></app-search-filter>
      </div>
      <!-- <span class="vertical-dash ml-18"></span>
      <button class="flex justify-center items-center context-menu-icon-filter height menu-btn pr-8 pl-8 pt-6 pb-6 ml-16 filter" (click)="filterColumns()">
        <mat-icon svgIcon="filter_alt" class="mr-4"></mat-icon>
        <span class="fw-500 filters">{{'TENANT_LIST.FILTERS' | transloco}}</span>
      </button> -->
    <!-- } -->
  </div>
    <div class="refresh-circle rounded-full w-32 h-32 flex items-center justify-center cursor-pointer" (click)="refreshClick()">
      <mat-icon svgIcon="refresh" class="icons transition-transform duration-700" [ngClass]="{ 'animate-spin': isRefreshing }"></mat-icon>
    </div>
</div>
<div *ngIf="selectedStatus?.length > 0 || filterStartDate && filterEndDate" class="flex flex-row items-center status-pill ml-36">
         <div class="mr-4 pt-8 pb-4 filtered-items flex items-center fs-16 fw-500" *ngIf="selectedStatus?.length > 0">
               <span *ngFor="let status of selectedStatus" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
                  {{getJobStatusLabel(status)}}
                  <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelStatusFilter(status)"></mat-icon>
               </span>
         </div>
         <div class="mr-4 pt-8 pb-4 filtered-items flex items-center fs-16 fw-500" *ngIf="filterStartDate && filterEndDate">
            <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
               <span class="date-label">{{'SCHEDULE_DETAILS.MODIFIED_DATE' | transloco}} :&nbsp; </span>{{ datePipe.transform(filterStartDate, 'dd MMM yyyy') }} - {{ datePipe.transform(filterEndDate, 'dd MMM yyyy') }}
               <span class="ml-8">
               <mat-icon svgIcon="close" class="cursor-pointer icon-sm" (click)="cancelJobDetailDateFilter()"></mat-icon>
               </span>
            </span>
         </div>
         <div class="flex flex-row items-center">
            <span *ngIf="selectedStatus?.length > 0  || (filterStartDate && filterEndDate)" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg" (click)="resetJobDetailFilter()">
               {{ 'BUTTONS.CLEAR_ALL' | transloco }}
            </span>
         </div>
      </div>
<mat-divider class="neutral-2 mb-12 ml-34 mr-34"></mat-divider>
<app-environment-table *ngIf="showTable" [showStageInfoIcon]="true" [initialDataSource]="tableData" [displayColumns]="displayColumns" [showSkeletonLoader]="jobDetailsLoading" [dataLoading]="jobDetailsLoading" [searchTerm]="searchTerm" [dataSourceLength]="true" [initialCreate]="jobDetails?.length === 0" (searchedResults)="searchedItems($event)" pageName="environmentJobs"></app-environment-table>